export default {
  organisations: [],
  unmappedUsers: [],
  organisationUser: null
}
